export const title = '使用条款和最终用户许可协议';

export const content = `
<h1>使用条款和最终用户许可协议</h1>
您对这些条款所在的网站、移动应用程序、平台和其他服务（统称为“平台”）的使用，包括通过本平台提供的功能和服务，均须遵守这些使用条款（“条款”） ）。 在使用本平台之前，请仔细阅读这些条款。该平台由 不做计划 拥有或控制。 ”或“我们”）。这些条款构成您与 不做计划地 之间具有法律约束力的协议。就这些条款而言，“您”和“您的”是指您作为平台的用户。

本平台仅适用于中国居民（年满 13 岁，未满 18 岁需获得父母或法定监护人的许可）。 如果您来自其他司法管辖区或未达到您所在司法管辖区规定的年龄限制，则您不得使用本平台。如果您未满 18 岁，则只有在您是中国居民并征得您父母或法定监护人同意的情况下才可以使用本平台。请确保您的父母或法定监护人已与您查看并讨论了这些条款。

通过以任何方式访问本平台，包括但不限于浏览本平台、使用任何信息和/或向公司提交信息，在法律允许的情况下，您同意其中包含的条款、条件、政策和通知并受其法律约束这些条款包括但不限于以电子方式进行交易、免责声明、损害和补救的排除和限制、有约束力的仲裁以及纽约法律的选择。

针对中国居民的仲裁通知：这些条款在第 10 节中包含仲裁条款。除该仲裁条款中提到的某些类型的争议外，您和公司同意我们之间的争议将通过强制约束性仲裁解决，并且您和公司放弃参与集体诉讼或集体仲裁的任何权利。

我们可能会不时更新本平台和这些条款。在我们发布对这些条款的任何更改后，您继续使用本平台即表示您同意这些更改。如果您不同意新条款，您必须停止访问或使用平台。您同意定期查看这些条款，以确保您熟悉最新版本。如果这些条款发生任何重大变更，我们将根据适用法律的要求，尽商业上合理的努力通知您。 此外，在使用特定服务时，您的交易或服务可能会受到适用于此类服务的附加条款和条件的约束，我们将让您知晓。 这可能包括促销、抽奖/竞赛以及某些交易的退货政策。

访问某些平台服务或平台功能（例如但不限于提交或共享用户内容（定义见下文）的能力）可能会受到年龄限制，并且不适用于平台的所有用户。

我们可能会在通知或不通知的情况下终止本平台或其任何部分，或者可能在通知或不通知您的情况下阻止您使用本平台。除非法律禁止，您同意您在本平台中不享有任何权利，并且如果本平台终止或您访问本平台的能力或您可能通过本平台提交的任何内容被终止，公司将不对您承担任何责任。您授予的所有限制、权利以及所有免责声明和责任限制在终止后仍然有效。

<h2>公司内容</h2>
本平台上由公司或其许可方提供的内容，包括包含在平台中或作为平台一部分的所有材料（包括平台的过去、现在和未来版本），包括但不限于：内容；软件;图形；插图；布局;文本;指示;照片、图像；声音的;视频；音乐或声音；设计；商标、服务标志、商业外观、标识、产品名称或包装以及口号；任何及所有受版权保护的材料（包括源代码和目标代码）；平台的“外观和感觉”；专利；可数字下载的文件以及所有上述内容的汇编（“公司内容”）是公司及其许可方的财产，并在中国和国际上受到商标、版权和其他知识产权法的保护。尽管有上述规定，您或您的许可方将拥有您通过平台上传或传输的任何用户内容（定义如下）。

您同意不下载、复制、复印、分发、传输、广播、展示、出售、许可或以其他方式使用任何公司内容 (a) 在任何出版物中，(b) 在公开表演中，(c) 在网站、应用程序、平台，或出于任何目的在本平台以外的服务中，(d) 与不属于公司的产品或服务有关，和/或 (e) 以任何其他可能导致消费者混淆、贬低的方式损害公司和/或其许可方或其各自的产品或品牌的声誉，削弱公司或其许可方知识产权的实力，或以其他方式侵犯公司或其许可方的知识产权。您进一步同意不会以其他方式滥用本平台上出现的任何公司内容或第三方内容。我们和我们的许可方保留公司内容中未明确授予的所有权利。

<h2>平台使用及发帖政策</h2>
根据这些条款，您特此被授予非排他性、有限性、不可转让、不可再许可、可撤销的全球许可，以访问和使用本平台，包括在允许的设备上下载本平台以及访问本公司内容仅供您通过使用平台且仅遵守这些条款的个人、非商业用途。公司保留平台和公司内容中未明确授予的所有权利。您承认并同意公司可以随时以任何理由或无理由终止本许可。
以下要求适用于您对平台的使用，包括您提供、提交、张贴、传输或展示的与平台相关的任何提交、文本、照片、视频、录音、数据、反馈或其他材料（“用户内容”）：
- 如果您无法合法同意这些条款，您将无法访问本平台；
- 如果您在中国未满 18 岁，则您没有获得父母或法定监护人访问平台的许可；
- 您不得将平台的任何电子通信功能用于任何非法、侵权、辱骂、侵犯他人隐私、骚扰、诽谤、诽谤、令人尴尬、淫秽、威胁、仇恨、侵犯他人隐私、辱骂的目的、种族主义、侵权、色情、暴力或公司确定的其他令人反感或不适当的内容；
- 未经版权或任何其他知识产权（以及公开权和隐私权）保护，您不得上传、发布、复制或分发任何信息、软件或其他材料；
- 您不会收集、存储或发布任何以下内容：
- 包含其他用户或任何个人的个人信息；
- 侵犯任何其他个人或实体的隐私/公开；
- 包含您有合同义务保密的任何内容；
- 包含任何受知识产权保护的图像、文字、声音、视频或其他内容，而您无权或许可以平台上预期的方式使用这些内容；
- 包含任何商业或公司广告（包括但不限于公司徽标、品牌名称和口号）、可识别的品牌产品或商业艺术品；
- 建议、描绘或描述任何不适当、非法或危险的行为或使用公司或任何其他产品或服务；
- 包含或描述任何有害或非法活动或内容，或以任何方式违反任何联邦、州或地方法律、规则或法规；
- 创建或暗示公司与任何个人或实体或其产品或服务之间的任何关联；
- 虚假、欺诈、欺骗、误导、诽谤、中伤、诽谤（包括商业诽谤）、贬低、非法骚扰、威胁、亵渎、淫秽、色情、仇恨、不雅、不适当或对任何其他方造成伤害；
- 描述或宣传摄入非食用物质并可能导致严重伤害；
- 鼓励可能导致伤害或财产损失的危险游戏、挑战、挑战或特技；
- 描绘、构成、鼓励、正常化、美化刑事犯罪、危险活动或自残或提供指示；
- 描绘、宣扬、规范或美化饮食失调；
- 描绘、宣扬、正常化或美化任何与饮食失调相关的危险减肥行为；
- 描述、招揽、宣传、正常化或美化未经同意的性行为或未经同意的亲密图像；
- 侮辱他人，或基于智力、外表、性格特征或卫生等属性贬低他人；
- 恐吓或骚扰他人；
- 宣扬露骨的色情内容、暴力或基于种族、性别、宗教、国籍、残疾、性取向或年龄的歧视；
- 故意挑衅或激怒他人，包括但不限于恶搞和欺凌，或意图骚扰、伤害、伤害、恐吓、困扰、尴尬或不安；
- 包含任何形式的威胁，包括身体暴力的威胁；
- 包含您未获得适当许可或没有资格提供的任何答案、回应、评论、意见、分析或建议；
- 公司自行判断，令人反感或限制或禁止任何其他人使用平台，或可能使公司、平台或其用户遭受任何类型的任何伤害或责任；
- 未经我们明确书面同意，您不得将本平台用于任何商业或未经授权的目的，包括传播或促进任何商业广告、招揽或垃圾邮件；
- 您不会上传、张贴、通过电子邮件发送或以其他方式传输任何广告或促销材料、“垃圾邮件”、“垃圾邮件”、“连锁信”、“传销”或任何其他形式的招揽或未经授权的通信；
- 您不得冒充任何个人、实体或组织，包括但不限于公司人员，或虚假陈述或以其他方式歪曲与其他人或组织的关系，包括给人留下这样的印象：您上传、发布、传输、分发的任何内容或以其他方式提供来自平台的信息；
- 您不得上传、发布、通过电子邮件发送或以其他方式传输任何包含病毒、恶意代码或任何其他可能中断、限制或干扰平台、任何计算机软件或平台功能的计算机代码、文件或程序的材料。硬件或电信设备；
- 您不会使用与平台相关的任何数据挖掘、爬虫、蜘蛛、机器人或类似的数据收集、抓取或提取方法；
- 您不得尝试修改、复制、改编、逆向工程、反向汇编、反向编译、反编译、反汇编、翻译或以其他方式改变、欺诈或从任何可执行代码、信息或由其接收的信息创建虚假结果。平台;
- 您不会收集或收集使用该平台的任何其他个人的个人信息；
- 您不得以收费或收费方式营销、出租或租赁本平台，或使用本平台进行广告或进行任何商业招揽；
- 您不会干扰或试图干扰平台的正常运行，破坏我们的网站或连接到平台的任何网络，或绕过我们可能用来阻止或限制访问平台的任何措施；
- 您不得将平台或其任何部分合并到任何其他程序或产品中。在这种情况下，我们保留自行决定拒绝服务、终止帐户或限制访问平台的权利；
- 您不会使用自动化脚本从平台收集信息或以其他方式与平台交互；
- 您不会在未经公司授权的情况下使用或试图使用他人的账户、服务或系统，或在平台上创建虚假身份；
- 您不会以可能造成利益冲突或破坏平台宗旨的方式使用平台；

除上述规定外，您同意您对平台的访问和使用应始终遵守我们的社区准则。

通过在平台上或通过平台展示、发布或以其他方式提交任何用户内容，您特此授予公司非排他性、可再许可、全球性、完全可转让、全额付款、不可撤销、永久、免版税的使用许可、修改、公开执行、公开展示、复制、改编、重新格式化、发布、广播、翻译、创建衍生作品、以任何格式、在任何平台上、以已知的任何及所有媒体或技术创建衍生作品、传输和分发此类用户内容或下文开发的，无需向您或任何第三方付款或需要寻求任何第三方许可。  该许可包括托管、索引、缓存、分发和标记任何用户内容、编辑和修改任何用户内容（恕不另行通知）的权利，以及将用户内容再许可给第三方的权利。您继续保留您的用户内容的所有所有权，并且您继续有权以您选择的任何方式使用您的用户内容，但须遵守这些条款和此处所述的许可。您进一步授予我们免版税许可，以使用您的用户名、图像、声音和肖像来识别您作为任何用户内容的来源；但是，由于年龄限制，您提供图像、声音和肖像的能力可能会受到限制。您确认您拥有您在平台上提交、展示、发布或发布的所有内容，并有权授予本文所述的许可，以及您提交的任何内容的展示、发布或发布，以及我们对此类内容的使用内容现在和将来都不会侵犯任何个人或实体的隐私权、公开权、版权、商标权、专利权、合同权或任何其他知识产权或其他权利。您进一步同意您通过本平台提供的所有信息均真实准确。任何用户内容将被视为非机密和非专有。您不得在平台上或通过平台发布任何用户内容，也不得向我们传输您认为机密或专有的任何用户内容。公司保留自行决定删除您提供的任何用户内容的权利，恕不另行通知。

您对您的行为以及您在平台上或通过平台提交、发布、传输或显示的任何数据承担全部责任。我们保留权利，但没有义务，在不另行通知的情况下删除、阻止和/或监控我们认为因任何原因违反这些条款或超出平台主题范围的任何用户。  我们进一步保留随时以任何理由或无理由自行决定删除或禁止访问内容或拒绝显示内容的权利，恕不另行通知。除了我们根据法律或衡平法可能采取的任何补救措施外，如果我们自行判断您已违反或可能违反这些条款，我们可能会采取我们认为必要的任何行动来纠正或防止违规行为。  在法律允许的范围内，我们对用户提交的以及我们或授权第三方发布的任何内容不承担任何责任。

如果您选择通过向我们或我们的员工发送有关产品、服务、功能、修改、增强、内容、改进、技术、内容产品（例如音频、视频、游戏或其他内容）的任何想法来提供有关平台的公司反馈或评论内容类型）、促销、策略或产品/功能名称，或任何相关文档、艺术品、计算机代码、图表或其他材料（统称为“反馈”），请注意，您发送的任何反馈均不被视为机密，并且公司不受限制以任何方式使用或披露它。

您不可撤销地授予公司永久且无限制的许可，以复制、分发、创建衍生作品、修改、公开表演（包括向观众传播）、向公众传播、提供、公开展示和以其他方式使用并出于任何目的、无限制、免费且无任何形式地利用反馈及其衍生产品，包括通过制作、使用、销售、许诺销售、进口和推广包含或体现反馈的商业产品和服务，无论是全部还是部分，无论是按规定还是按修改。

<h2>服务费用及退款政策</h2>
平台的某些功能（例如广播服务）可供购买，您需要支付一定的费用和成本（“服务费”）才能使用需要缴纳服务费的功能（“付费功能”）。服务费由我们自行决定。服务费可能会有所不同，具体取决于付费功能的类型。当您决定购买付费功能时，将向您显示服务费。您始终可以选择接受或拒绝服务费。但是，如果您拒绝支付服务费，您将无法访问、查看或使用与服务费相关的付费功能。如果您购买广播服务，您将收到该特定付费功能的服务费，如果您接受，我们将暂时冻结您的付款方式，授权我们通过您的付款方式收取这笔金额，用户内容获得批准后。如果您的用户内容被拒绝，我们将不会向您收取任何费用，并且我们将自动取消对您的付款方式的保留。

所有用户内容均受第 2 部分中的发布政策和内容指南的约束。当您购买广播服务等付费功能时，您将需要接受服务费，这将暂停您支付服务费金额的方式。但是，提交用户内容并接受服务费并不能保证您的用户内容将被公开显示。我们不承诺或保证您的用户内容将在任何情况下或在选定的时间段内广播。如果您的用户内容被拒绝或您选择的时间段不再可用，我们将与您联系。

如果您的用户内容被拒绝，我们将取消授权保留，并且您无需支付与该用户内容相关的任何服务费。如果您的用户内容根据请求或经您批准而被批准并安排广播，则将向您的付款方式收取服务费。

我们不提供与已完成的付费功能相关的任何退款。例如，如果您购买广播服务并且您的用户内容已经广播，我们将不会向您退还为此类已完成的服务支付的任何服务费。如果您对所购买的广播服务的任何方面不满意，请站内联系服务管家。

如果我们自行判断您上传的用户内容之前已被拒绝或明显不符合我们的发布政策和社区准则，目的是为了骚扰、骚扰或滥用我们或平台，我们可能选择不退还与此类交易相关的服务费，和/或终止、阻止或暂停您对平台的访问或阻止您购买任何额外的付费功能。

<h2>版权侵权索赔程序</h2>
正如公司要求他人尊重其知识产权一样，公司也尊重他人的知识产权，并期望其平台的用户也这样做。公司在适当情况下可以从平台中删除可能侵犯他人知识产权的信息。

<h2>收到适当的侵权通知</h2>
一旦指定代理收到适当的善意侵权通知，公司的政策是：
-删除或禁止访问侵权内容；
-通知内容提供商、会员或用户（“内容提供商”）已删除或禁止访问内容；和
-屡犯者将从系统中删除侵权内容，并且公司可以终止此类内容提供商对平台的访问。
-向指定代理人提供反通知的程序

如果内容提供商认为被删除或被禁止访问的内容不侵权，或者内容提供商认为其有权发布和使用此类内容，则内容提供商可以向指定代理发送反通知，其中必须包含以下内容：
-内容提供商的联系信息，包括提交者的法定全名（而非公司名称）、电子邮件地址、实际地址和电话号码。
-已删除或禁用的内容的位置，包括任何 URL。

<h2>用户帐户/注册</h2>
平台的某些区域需要注册或以其他方式要求您提供信息才能参与某些功能或访问某些内容或创建用户帐户以访问某些服务（“用户帐户”）。为了创建用户帐户，通过提供所需信息（例如您的手机号码）进行注册。如果您选择不提供此类信息，您可能无法访问某些内容或参与平台的某些功能，或根本无法使用任何功能。

创建用户帐户即表示您同意： (a) 提供有关您自己的准确、最新且完整的信息； (b) 维护并根据需要及时更新您的信息； (c) 维护您的密码的安全，并接受涉及您的电子邮件和密码组合以及您向我们提供的信息的未经授权访问的所有风险； (d) 如果您发现或怀疑任何与平台或您的电子邮件和密码组合相关的安全漏洞，请立即通知我们； (e) 您仅为自己使用我们的平台，不得代表任何第三方，除非获得该第三方的授权； (f) 您对您的用户帐户下在平台上发生的所有活动负全部责任。我们可以自行决定拒绝您创建用户帐户，或限制您可以与平台关联的用户帐户数量，或暂停或终止任何用户帐户或对平台的访问。

您还同意您不会：
- 创建多个用户帐户；
- 如果我们禁止您使用不同的用户帐户访问平台，请使用不同的用户帐户使用平台，除非您首先获得我们的书面许可；
- 通过您的电子邮件和密码组合或关联帐户向任何第三方购买、出售、出租或出租平台访问权限，除非您事先获得我们的书面许可；
- 与任何人分享您的电子邮件和密码组合或用户帐户的访问权限；或者
- 通过任何未经授权的第三方应用程序或客户端登录或尝试登录访问平台。

<h2>暂停、终止、取消</h2>
公司可以自行决定并在发出或不发出通知的情况下：(a) 暂停、限制或终止您对任何或全部平台的访问，和/或 (b) 停用或取消您的用户帐户原因，包括但不限于以下情况：(i) 您所在地区的表面有效的传票或同等文件、法院命令或任何政府机构的具有约束力的命令要求我们这样做； (ii) 我们有理由怀疑您将平台用于任何禁止用途（定义如下）； (iii) 您对平台的使用受到任何未决诉讼、调查或政府程序的约束，和/或我们自行判断认为与您的活动相关的法律或监管不合规风险较高； (iv) 我们的任何服务合作伙伴无法支持您的使用； (v) 您采取公司自行判断认为规避公司控制或滥用公司可能不时提供的促销活动的任何行动； (vi) 我们停止提供全部或部分平台或通过平台提供的服务； (vii) 您违反了这些条款。

您承认公司决定采取某些行动，包括限制访问或暂停您的用户帐户，可能基于对公司风险管理和/或安全协议至关重要的机密标准。您承认公司没有义务向您披露其风险管理和/或安全程序的详细信息。

<h2>责任</h2>
公司对本平台功能、公司内容或任何其他平台功能的可靠性不做任何保证，并且在法律允许的情况下，对任何服务故障不承担任何责任。您承认您不应依赖本平台。公司不保证任何公司内容或用户内容的保留时间。公司不保证从或通过平台获得的任何材料、图像、应用程序或文件不存在计算机病毒或其他故障或缺陷。您有责任采取合理的预防措施，防范计算机病毒和/或平台上或平台上或通过平台提供的应用程序或材料上的不准确、印刷错误或其他缺陷。

公司不认可、验证、评估或保证任何用户内容或用户提供的其他信息，除非明确说明，否则任何内容均不应被视为对任何用户内容的认可、验证或保证。其他用户在平台和用户内容中表达的观点并不代表我们的观点或价值观。我们不以明示或暗示的方式声明、保证或保证任何公司内容（包括用户内容）的准确性、完整性或最新性。未经事先审查和书面批准，您不得创建或分发信息，包括但不限于广告、新闻稿或其他营销材料，或包含包含或暗示公司（包括其人员和所有者）认可的任何网站的链接公司的。

本平台和平台更新均按“原样、可用”基础提供。在法律允许的最大范围内，不提供任何明示或暗示的保证或保证，包括但不限于适销性或特定用途的适用性、非侵权、所有权、定制、贸易、安静享受、系统集成和自由来自计算机病毒，针对本平台或本平台上的任何信息或软件而制作。通过访问或使用本平台，您承诺您的活动在您访问或使用本平台所在的司法管辖区是合法的。

<h2>第三方网站</h2>
本平台可能会超链接到并非由公司维护或与公司无关的网站。超链接作为一项服务提供给用户，并非由本平台或公司赞助或附属于本平台或公司，公司不保证这些第三方网站的内容、完整性或准确性。您在可从本平台访问的第三方网站上提交的信息受该网站的条款和条件以及隐私政策的约束，公司无法控制您的信息的收集、使用或以其他方式处理方式。包含指向第三方网站或服务的任何链接并不一定意味着公司认可该第三方或从属于该第三方。您承认并同意，公司对任何此类第三方网站或服务不承担任何责任或义务。

<h2>无第三方权利</h2>
除非这些条款中明确指出相反的情况，否则本文中的任何内容均无意向您、公司以及我们的继承人和受让人以外的任何人授予任何权利或补救措施。这些条款中的任何内容均无意减轻或免除任何第三方对您和公司以及我们的继承人和受让人的义务或责任，任何条款也不赋予任何第三方对您、公司和我们的代位权或诉讼的权利。继任者和受让人。

<h2>移动服务、互联网和服务费</h2>
使用平台可能需要使用移动设备和无线移动数据服务（必须从您的无线运营商处获得），并且可能需要互联网接入（必须从您的服务提供商处获得）；您有责任获取并支付此类附加服务以及获取合适的设备，包括但不限于与之相关的所有使用费用。  您需要自费发送和接收来自公司、您的移动运营商或第三方服务提供商的与平台相关的电子通信，包括但不限于管理消息、服务公告、诊断数据报告和平台更新。  如果您没有无限制的无线移动数据套餐，则您的无线服务提供商可能会向您收取与使用平台相关的额外费用。您全权负责获取访问平台所需的任何额外订阅或连接服务或设备，包括但不限于支付与此相关的所有第三方费用，包括发送到平台或通过平台发送信息的费用。

该平台可能不适用于所有设备或所有移动运营商。  公司不保证该平台将与所有移动运营商兼容或由所有移动运营商提供。  如果平台收费，或其他第三方服务提供商对其提供的产品或服务收取费用，您同意向相关方支付该费用，以换取您继续使用该等产品或服务。  某些服务可能受不同或附加条款（包括费用）的约束，您在使用此类服务之前需要同意这些条款。

<h2>其他</h2>
您和公司均承认并同意，不存在任何合伙关系，并且您和公司均无权力或职权使对方承担义务或约束对方。

在我们平台的某些区域，您可能能够向我们提供个人身份信息。请阅读我们的隐私政策，了解有关我们的信息收集和使用惯例的更多信息。

由于天灾、流行病、爆发、战争、火灾、骚乱、恐怖主义、地震、地方政府当局的行动或超出公司合理控制范围的任何其他原因，公司未能遵守这些条款，不应被视为违反这些条款。

公司未能行使或执行这些条款的任何权利或规定不应被视为在该情况或任何其他情况下放弃该权利或规定。我们可以随时转让这些条款，恕不另行通知。您不得转让给其他任何人，您的任何转让尝试均无效。如果您不遵守这些条款，并且我们没有立即采取行动，这并不意味着我们放弃我们可能拥有的任何权利（例如将来采取行动）。

如果这些条款的任何规定非法、无效或因任何原因无法执行，则该规定应被视为与这些使用条款分开，并且不影响任何其余规定的有效性和可执行性。

这些条款构成您与公司之间具有约束力的协议。这些条款构成您和公司之间关于使用平台和您的帐户的完整协议。通过使用该平台，您同意您有能力签订具有约束力的协议，并且您同意受这些条款的约束。
`;
